<template>
  <div class="after_loan_table">
    <basic-container>
      <div class="after_loan bankmanageDetail">
        <div class="bankdetail_title">
          <div class="banktail_">
            <div class="bank_nameblock">
              <div class="bankname">{{ info.placementTitle }}</div>
            </div>
            <div class="bankcontent">
              <Detaillist
              :detaillist="detaillist"
              :data="info"
              
             />
              <!-- <el-row :gutter="20">
                <el-col :span="5">
                  <div class="grid_content">
                    <span class="banktitle_content">本金:</span>
                    <span>{{ getMoney(info.amtPlacement) }}</span>
                  </div>
                  <div class="grid_content">
                    <span class="banktitle_content">应收使用费:</span>
                    <span> {{ getMoney(info.interestReceivable) }}</span>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="grid_content">
                    <span class="banktitle_content">已还使用费:</span>
                    <span>{{ getMoney(info.collectionAmount) }}</span>
                  </div>
                  <div class="grid_content">
                    <span class="banktitle_content"> 已还使用费:</span>
                    <span>{{getMoney( info.interestPaid )}}</span>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="grid_content">
                    <span class="banktitle_content">剩余本金:</span>
                    <span>{{ getMoney(info.remainingPrincipal) }}</span>
                  </div>
                  <div class="grid_content">
                    <span class="banktitle_content">剩余使用费:</span>
                    <span>{{ getMoney(info.remainingInterest) }}</span>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="grid_content">
                    <span class="banktitle_content">投放日期:</span>
                    <span>{{ info.verificationTime }}</span>
                  </div>
                  <div class="grid_content">
                    <span class="banktitle_content">使用天数:</span>
                    <span>{{ info.expectUseDay>-1?info.expectUseDay:'-' }}</span>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="grid_content examine">
                    <div class="shstate">
                      <div class="list_top">
                        <div class="stateTop">贷款状态</div>
                        <div
                          :class="[
                            'stateTopdiv',
                            'auditState_' + info.loanStatus,
                          ]"
                        >
                          {{ info.loanStatusName }}
                        </div>
                      </div>
                    </div>
                  </div></el-col
                >
              </el-row> -->
            </div>
            <div>
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane class="activelabel" label="付款列表" name="1">
                  <div class="informationxm">
                    <div class="form_wrapper">
                      <div class="form_header">
                        <div class="form_header_name">数据列表</div>
                        <div class="form_header_remarks"></div>
                      </div>
                      <div class="form_content">
                        <PaymentManage ref="paymentManage" :data="dataList" />
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane class="activelabel" label="收款列表" name="2">
                  <div class="informationxm">
                    <div class="form_wrapper">
                      <div class="form_header">
                        <div class="form_header_name">数据列表</div>
                        <div class="form_header_remarks"></div>
                      </div>
                      <div class="form_content">
                        <CollectionManage
                          ref="collectionManage"
                          :data="dataList"
                        />
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane class="activelabel" label="费用测算工具" name="3">
                 <div class="informationxm">
                    <div class="form_wrapper">
                      <div class="form_header">
                        <div class="form_header_name">数据列表</div>
                        <div class="form_header_remarks">
                          共产生使用费：{{ getMoney(interestJournals.all?Number(interestJournals.all).toFixed(2):'') }}元；正常使用费{{
                            getMoney(interestJournals.normal?Number(interestJournals.normal).toFixed(2):'')
                          }}元，超期使用费{{ getMoney(interestJournals.overdue?Number(interestJournals.overdue).toFixed(2):'')}}元
                        </div>
                      </div>
                      <div class="form_content">
                        <InterestManage ref="interestManage" :data="dataList" />
                      </div>
                    </div>
                 </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
    </basic-container>
  </div>
</template>

<script>

import * as api from "@/api/zd/afterLoan";
import * as dictionaries from "@/api/zd/dictionaries";
import PaymentManage from "./components/paymentManage";
import CollectionManage from "./components/collectionManage";
import InterestManage from "./components/interestManage";
import Detaillist from "@/components/detail/detaillist";

export default {
  name: "afterLoanDetail",
  data() {
    return {
      activeName: "1",

      info: {},
      dataList: [],
      interestJournals: {},
      detaillist: {
        column: [
          {
            label: "本金",
            prop: "amtPlacement",
            formatter: () => {
              return this.getMoney(this.info.amtPlacement)+' 元';
            },
          },
          {
            label: "已还本金",
            prop: "collectionAmount",
            formatter: () => {
              return this.getMoney(this.info.collectionAmount)+' 元';
            },
          },
          {
            label: "剩余本金",
            prop: "remainingPrincipal",
            formatter: () => {
              return this.getMoney(this.info.remainingPrincipal)+' 元';
            },
          },
          {
            label: "投放日期",
            prop: "verificationTime",
            
          },
          {
            label: "应收使用费",
            prop: "interestReceivable",
            formatter: () => {
              return this.getMoney(this.info.interestReceivable) +' 元';
            },
          },
          {
            label: "已还使用费",
            prop: "interestPaid",
            formatter: () => {
              return this.getMoney(this.info.interestPaid) +' 元';
            },
          },
          {
            label: "剩余使用费",
            prop: "remainingInterest",
            formatter: () => {
              return this.getMoney(this.info.remainingInterest) +' 元';
            },
          },
          {
            label: "预计使用天数",
            prop: "expectUseDay",
            formatter: () => {
              return this.info.expectUseDay>-1?this.info.expectUseDay+' 天':'-'
            },
          },
          {
            label: "实际使用天数",
            prop: "realUsingDay",
            formatter: () => {
              return this.info.realUsingDay>-1?this.info.realUsingDay+'天':'本金待收回'
            },
          },
          
        ],
        showcolumn: [
          {
            label: "贷款状态",
            prop: "loanStatus",
            state: 0,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=loan_status",
          },
          
          
        ],
        firstsblock: {
          formatter: () => {
            return 19;
          },
        },
        sentersblock: {
          formatter: () => {
            return 5
          },
        },

        firstrow: {
          formatter: () => {
            return {
              width: "25%",
            };
          },
        },
        secondrow: {
          formatter: () => {
            return {
              width: "25%",
            };
          },
        },
        thirdrow: {
          formatter: () => {
            return {
              width: "25%",
            };
          },
        },
      },
    };
  },
  computed: {
    
  },
  components: {
    PaymentManage,
    CollectionManage,
    InterestManage,
    Detaillist
  },
  created() {
    this.getInfo(this.activeName);
  },
  methods: {
    getInfo(type) {
      api
        .getInfoAfter({ id: this.$route.params.id, type })
        .then((res) => {
          let info = res.data.data.info;
          info.loanStatusName = "";

          this.info = info;
          this.dataList = res.data.data.list;
          if (type == 3) {
            this.interestJournals = res.data.data.interestJournals;
          }
         
          // this.loanStatus(this.info.loanStatus);
        })
        .catch((res) => {
          
        });
    },
    // loanStatus(data) {
    //   dictionaries.dictionaries("loan_status").then((res) => {
    //     this.$nextTick(() => {
    //       const index = this.findArray(res.data.data, data + "", "dictKey");
    //       this.info.loanStatusName =
    //         index > -1 ? res.data.data[index].dictValue : "";
    //     });
    //   });
    // },
    handleClick(tab, event) {
      this.getInfo(tab.name);
    },
  },
};
</script>

<style lang="scss" scoped>
.bankmanageDetail {
  .bankdetail_title {
    background: #fff;
    padding-top: 25px;
    padding-bottom: 25px;
    position: relative;
  }
  .history {
    position: absolute;
    top: 50%;
    right: -15px;
    .history_content {
      width: 100px;
      height: 35px;
      background: #409eff;
      line-height: 35px;
      color: #fff;
      text-align: right;
      padding-right: 15px;
      border-radius: 5px 0 0 5px;
    }
  }
  .banktail_ {
    width: 1000px;
    // width: 100%;
    margin: 0 auto;
  }
  .bank_nameblock {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    .bankname {
      font-size: 18px;
      color: #333;
      font-weight: 700;
    }
  }
  .bankcontent {
     position: relative;
    margin: 20px 0;
    .grid_content {
      line-height: 35px;
      color: #333333;
      font-size: 13px;
      // margin-bottom: 15px;
      display: flex;
      flex-wrap: wrap;
      word-break:break-all; 
      .banktitle_content {
        color: #999999;
        margin-right: 15px;
        
      }
      .shstate {
        display: flex;
        flex-direction: row;
        text-align: center;
        .list_top {
          flex: 1;
        }
        .stateTop {
          color: rgb(187, 185, 185);
        }
        .stateTop + div {
          font-size: 20px;
        }
        .stateTopdiv::before {
          content: "";
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 5px;
        }
      }
      .data_ {
        margin-top: 25px;
        text-align: right;
        .stateTop {
          color: rgb(187, 185, 185);
        }
        .stateTop + div {
          font-size: 20px;
          font-weight: bolder;
        }
      }
    }
  }
}

.banktail_ .el-tabs__item {
  font-size: 18px;
  font-weight: bolder;
  margin-bottom: 10px;
}
.bankstate_0:before {
  background: #fec03d;
}
.bankstate_1:before {
  background: #51d351;
}
.bankstate_2:before {
  background: #ff7a8c;
}

.auditState_0:before {
  background: #fec03d;
}
.auditState_1:before {
  background: #409eff;
}
.auditState_2:before {
  background: #ff7a8c;
}
.warningblock {
  cursor: pointer;
  color: rgb(197, 192, 192);
}
.box_card {
  width: 100%;
  box-shadow: 1px 1px 5px #ddd;
  margin: 20px 0;
  .demo-basic {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 13px;
  }
}
.autilog {
  display: flex;
  flex-direction: column;
}
.warningtext {
  color: rgb(197, 192, 192);
  font-size: 12px;
}
.bankmanageDetail .el-tabs__item.is-active {
  background: none;
}
.box_cards {
  height: 450px;
  overflow-y: auto;
}

.form_wrapper {
  height: 100%;
  box-sizing: border-box;
  // border-width: 1px;
  // border-style: solid;
  // border-color: rgba(233, 233, 233, 1);
  border-radius: 10px;
  background-color: #fff;
  .form_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 0px;
    height: 60px;
    border:1px solid  rgba(233, 233, 233, 1);
    background-color: rgba(249, 249, 249, 1);
   
    padding: 0 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: none;
    
    .form_header_name {
      font-weight: 700;
      color: #333;
      font-size: 16px;
    }
    .form_header_remarks {
      color: #999999;
      font-size: 13px;
      .red_color {
        color: #ff3b30;
      }
    }
  }
  
  .form_content_form {
    padding: 20px 50px;
    border:1px solid #e2e2e2
  }
}
.label_name {
  font-weight: 900;
  color: #666666;
  position: relative;
  margin: 30px 0;
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: -15px;
    transform: translate(0, -50%);
    height: 18px;
    width: 6px;
    background-color: #409eff;
  }
}
/deep/.el-tabs__header {
  margin: 0px;
}
/deep/ .avue-crud {
  width:100%
}
/deep/ .avue-crud__menu {
  display: none;
}
.informationxm {
  margin-top: 20px;
}
/deep/.avue-crud .el-table th{
  background-color: #ffffff;
  line-height: 50px;
    padding: 0; 
}
/deep/.el-table .cell, .el-table th>.cell{
  padding-left: 20px;
}
/deep/.el-table__empty-block{
      border-right:none;
}
</style>
<style >
.after_loan_table .table_custom_add .el-button {
  width: 100%;
  height: 47px;
}
.after_loan_table .el-input-number {
  width: 100%;
}

.after_loan_table .avue-crud__pagination {
  padding: 0;
}
.after_loan_table .avue-crud {
  width: 100%;
}
.after_loan_table .avue-crud__menu {
  display: none;
}
</style>